import { RouteLocationNormalized } from 'vue-router';

const state = () => ({
	showGlobalLoader: false,
	previousRoute: null as RouteLocationNormalized | null,
});

export default state;
